import { Component, OnInit } from '@angular/core';
import { slideInAnimation } from 'src/app/route-animate';

@Component({
  selector: 'app-blog-page',
  templateUrl: './blog-page.component.html',
  styleUrls: ['./blog-page.component.css'],
  animations: [slideInAnimation],
})
export class BlogPageComponent implements OnInit { 
  constructor() {}

  ngOnInit(): void {} 
}

